(function () {

	angular
		.module('ngmvac')
		.filter('conteoParaFiltros', ConteoParaFiltros);

	function ConteoParaFiltros() {

		return function (arr) {

			var ndesc = 0;
			var est1 = 0;
			var est2 = 0;
			var est3 = 0;
			var est4 = 0;
			var est5 = 0;
			var est6 = 0;
			var est7 = 0;
			var est8 = 0;
			var contador = [];
			
			for (var i = 0; i < arr.length; i++) {
				if ( angular.isDefined(arr[i].discount != 0 )) {
					ndesc++;
				}
				if (angular.isDefined(arr[i].rooms)) {
					for (var a = 0; a < arr[i].rooms.length; a++) {
						// if ( angular.isDefined(arr[i].rooms[0].rates[0].offers )) {
						// if ( angular.isDefined(arr[i].discount != 0 )) {
						// 	ndesc++;
						// }
						if ( angular.isDefined(arr[i].rooms[0].rates[0].promotions) ) {
							est7++;
						}
						break;
					}
				}
				if (angular.isDefined(arr[i].categoryCode)) {
					if (arr[i].categoryCode == '1EST' || arr[i].categoryCode == 'H1_5') {
						est1++;
					} else if (arr[i].categoryCode == '2EST' || arr[i].categoryCode == '2' || arr[i].categoryCode == 'H2_5') {
						est2++;
					} else if (arr[i].categoryCode == '3EST' || arr[i].categoryCode == '3' || arr[i].categoryCode == 'H3_5') {
						est3++;
					} else if (arr[i].categoryCode == '4EST' || arr[i].categoryCode == '4LUX' || arr[i].categoryCode == 'H4_5') {
						est4++;
					} else if (arr[i].categoryCode == '5EST' || arr[i].categoryCode == '5LUX' || arr[i].categoryCode == 'H5_5') {
						est5++;
					} else{
						est6++
					}
				}
				if (angular.isDefined(arr[i].packageGrouped)) {
					for (var igroup = 0; igroup < arr[i].packageGrouped.length; igroup++) {
						for (var ipackage = 0; ipackage < arr[i].packageGroup[igroup]; ipackage++) {
							if (angular.isDefined(arr[i].packageGroup[igroup][ipackage].car)) {
								
							}
						}
					}

					// var estadoAnterior = est8;
					// angular.forEach(arr[i].packageGrouped, function (group) {
					// 	angular.forEach(group, function (packageGroup) {
					// 		if (angular.isDefined(packageGroup.car)) {
					// 			if (estadoAnterior == est8) {
					// 				est8++;
					// 			}
					// 		} 
					// 	});
					// });
				}
			}
			contador.push(ndesc, est1, est2, est3, est4, est5, est6, est7);
			return contador;
		}
	}

})();